<template>
  <div ref="main-page" class="tree-okr">
    <b-card class="no-shadow">
      <b-row class="mx-0 align-items-center top-search">
        <!-- Search -->
        <b-col cols="12" class="px-0">
          <div class="d-flex align-items-center pl-0 filter-data justify-content-between">
            <div class="search-okr">
              <b-input-group class="input-group-merge round w-100">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block"
                  placeholder="Search by Name or OKR Title"
                   @focus="show=true"
                  @input="onSearch(searchQuery)" @keydown.enter.prevent="search(searchQuery,'okr_title')"
                />
              </b-input-group>
              <ul v-if="searchResults.length > 0 && show" class="suggestions-list">
                <li 
                v-for="suggestion in searchResults" @click="search(suggestion,'employee_id')">
                  {{ suggestion.label }}
                </li>
              </ul>
            </div>
            <div class="okr-optionselect d-flex align-items-center">
              <div class="expand-collapse">
                <b-button v-if="isCollapsed" class="mr-1"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-secondary" pill
                    @click="expand()"
                  >
                    Expand
                  </b-button>
                  <b-button v-else class="mr-1"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-secondary" pill
                    @click="collapse()"
                  >
                    Collapse
                  </b-button>
                </div>
              <div class="d-flex align-items-center list-grid">
                <div class="org-list select-option"  @click="goto('all-okrs')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <g clip-path="url(#clip0_7716_60299)">
                      <path d="M9.5 6H20.5" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9.5 12H20.5" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9.5 18H20.5" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M5.5 6V6.01" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M5.5 12V12.01" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M5.5 18V18.01" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_7716_60299">
                        <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="org-tree select-option" @click="goto('tree-okrs')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <g clip-path="url(#clip0_7591_14363)"> <path d="M12.1693 4.99967C12.1693 4.55765 11.9937 4.13372 11.6811 3.82116C11.3686 3.5086 10.9446 3.33301 10.5026 3.33301C10.0606 3.33301 9.63665 3.5086 9.32409 3.82116C9.01153 4.13372 8.83594 4.55765 8.83594 4.99967C8.83594 5.4417 9.01153 5.86563 9.32409 6.17819C9.63665 6.49075 10.0606 6.66634 10.5026 6.66634C10.9446 6.66634 11.3686 6.49075 11.6811 6.17819C11.9937 5.86563 12.1693 5.4417 12.1693 4.99967Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M6.33333 11.6667C6.33333 11.2246 6.15774 10.8007 5.84518 10.4882C5.53262 10.1756 5.10869 10 4.66667 10C4.22464 10 3.80072 10.1756 3.48816 10.4882C3.17559 10.8007 3 11.2246 3 11.6667C3 12.1087 3.17559 12.5326 3.48816 12.8452C3.80072 13.1577 4.22464 13.3333 4.66667 13.3333C5.10869 13.3333 5.53262 13.1577 5.84518 12.8452C6.15774 12.5326 6.33333 12.1087 6.33333 11.6667Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M17.9974 11.6667C17.9974 11.2246 17.8218 10.8007 17.5092 10.4882C17.1967 10.1756 16.7728 10 16.3307 10C15.8887 10 15.4648 10.1756 15.1522 10.4882C14.8397 10.8007 14.6641 11.2246 14.6641 11.6667C14.6641 12.1087 14.8397 12.5326 15.1522 12.8452C15.4648 13.1577 15.8887 13.3333 16.3307 13.3333C16.7728 13.3333 17.1967 13.1577 17.5092 12.8452C17.8218 12.5326 17.9974 12.1087 17.9974 11.6667Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M12.1693 14.9997C12.1693 14.5576 11.9937 14.1337 11.6811 13.8212C11.3686 13.5086 10.9446 13.333 10.5026 13.333C10.0606 13.333 9.63665 13.5086 9.32409 13.8212C9.01153 14.1337 8.83594 14.5576 8.83594 14.9997C8.83594 15.4417 9.01153 15.8656 9.32409 16.1782C9.63665 16.4907 10.0606 16.6663 10.5026 16.6663C10.9446 16.6663 11.3686 16.4907 11.6811 16.1782C11.9937 15.8656 12.1693 15.4417 12.1693 14.9997Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M10.5 6.66699V13.3337" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M5.76562 10.4129L9.40563 6.25293" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>  <path d="M15.2399 10.4132L11.6016 6.25488" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g>
                    <defs>
                      <clipPath id="clip0_7591_14363">
                        <rect width="20" height="20" fill="white" transform="translate(0.5)"/>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="company-tree select-option" @click="goto('company-tree-okrs')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M2.5 17.5H17.5M7.5 6.66667H8.33333M7.5 10H8.33333M7.5 13.3333H8.33333M11.6667 6.66667H12.5M11.6667 10H12.5M11.6667 13.3333H12.5M4.16667 17.5V4.16667C4.16667 3.72464 4.34226 3.30072 4.65482 2.98816C4.96738 2.67559 5.39131 2.5 5.83333 2.5H14.1667C14.6087 2.5 15.0326 2.67559 15.3452 2.98816C15.6577 3.30072 15.8333 3.72464 15.8333 4.16667V17.5" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
              <b-dropdown :text="selectedPeriod.quarter+', '+selectedPeriod.year" class="custom-dropdown ml-1" variant="outline-secondary">
                <b-dropdown-item v-for="period in periods" @click="selectedPeriod = period">{{ period.quarter }}, {{period.year}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-collapse class="" id="showtreeview" visible accordion="my-accordion" role="tabpanel">
        <div class="treecontent" id="treecontent">
          <div class="d-flex align-items-center justify-content-end pt-2">
            <button id="fullscreenIcon" type="button"><feather-icon icon="MinimizeIcon" size="20" class="max" /><feather-icon icon="MaximizeIcon" size="20" class="min"/></button>
          </div>
          <!-- Vertical Company View Tree Design in Reporting Order -->
          <div class="okrgrid-body teamgoal-scroll px-0 pt-0" v-if="nodes">
            <div class="okr-tree mt-1" id="okr-tree">
              <ul class="m-0 p-0 main-tree" style="padding-top: 0 !important;">
                <li id='org-tree'>
                  <b-card class="relative mb-0 company-logo">
                    <div class="emp-pic">
                      <b-img :src="companyData['logo']" class="w-100 pro-img" fluid  alt="profile photo"></b-img>
                    </div>
                    <b-button id="root-node-arrow" class="expand-icon " v-if="nodes && nodes.length"  @click="listClicked('org-tree')">
                      <feather-icon icon="PlusIcon" size="20" class="before-expand" />
                      <feather-icon icon="MinusIcon" size="20" class="after-expand" />
                    </b-button>
                  </b-card>
                  <nodes v-if="nodes && nodes.length" :nodes="nodes" parent="org-tree" :ref="'children-org-tree'"></nodes>
                  <!-- <div>
                    <ul :id="'children-'+parent">
                      <li style="padding-left: 0;margin-bottom:20px;">
                          <b-card class="relative text-left mb-0 item">
                                        <div class="mb-0 w-100">
                                          <div class="goal-header text-center d-flex align-items-center justify-content-between">
                                            <h5 class="mb-0 obje-name font-weight-bolder mr-2">Revenue for Q1, 2024</h5>
                                            <div class="circle_percent" data-percent="50">
                                              <div class="circle_inner">
                                                <div class="round_per"></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="obj-period d-flex align-ites-center">
                                          <div class="quarter-data">
                                            <h6 class="mb-0 text-left">Period</h6>
                                            <p class="value text-left mb-0">Q6</p>
                                          </div>
                                        </div>
                                        <b-button id="root-node-arrow" class="expand-icon" @click="listClicked(person.hashid);">
                                          <feather-icon icon="PlusIcon" size="18" class="text-primary font-weight-bolder m-0"  /></b-button>
                                      </b-card>
                          <div>
                        <ul class="team-okr" style="display: flex">
                          <li>
                            <b-card class="relative mb-0">
                              <div class="mb-0 w-100">
                                <b-badge variant="info" class="badge team-badge"> Team </b-badge>
                                <div class="goal-header text-center d-flex align-items-center justify-content-between">
                                  <h5 class="mb-0 obje-name font-weight-bolder mr-2">Revenue for Q1, 2024</h5>
                                  <div class="circle_percent" data-percent="20">
                                    <div class="circle_inner">
                                      <div class="round_per"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center okr-objtype">
                                <div class="obj-name d-flex align-ites-center">
                                  <div class="quarter-data">
                                    <h6 class="mb-0 text-left">Team</h6>
                                    <p class="value text-left mb-0">Zircly</p>
                                  </div>
                                </div>
                                <div class="obj-period d-flex align-ites-center">
                                  <div class="quarter-data">
                                    <h6 class="mb-0 text-left">Period</h6>
                                    <p class="value text-left mb-0">Q6</p>
                                  </div>
                                </div>
                              </div>
                              <b-button class="expand-icon"><feather-icon icon="PlusIcon" size="18" class="text-primary font-weight-bolder m-0" /></b-button>
                            </b-card>
                            <div>
                              <ul class="third-node" style="display: block">
                                <li>
                                  <b-card class="relative mb-0">
                                    <div class="mb-0 w-100">
                                      <b-badge variant="info" class="badge individual-badge"> Individual </b-badge>
                                      <div class="goal-header text-center d-flex align-items-center justify-content-between">
                                        <h5 class="mb-0 obje-name font-weight-bolder mr-2">Revenue for Q1, 2024</h5>
                                        <div class="circle_percent" data-percent="20">
                                          <div class="circle_inner">
                                            <div class="round_per"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="d-flex align-items-center okr-objtype">
                                      <div class="obj-name d-flex align-ites-center">
                                        <div class="quarter-data">
                                          <h6 class="mb-0 text-left">Name</h6>
                                          <p class="value text-left mb-0">Vignesvaran B</p>
                                        </div>
                                      </div>
                                      <div class="obj-period d-flex align-ites-center">
                                        <div class="quarter-data">
                                          <h6 class="mb-0 text-left">Period</h6>
                                          <p class="value text-left mb-0">Q6</p>
                                        </div>
                                      </div>
                                    </div>
                                    <b-button class="expand-icon"><feather-icon icon="PlusIcon" size="18" class="text-primary font-weight-bolder m-0" /></b-button>
                                  </b-card>
                                </li>
                                <li>
                                  <b-card class="relative mb-0">
                                    <div class="mb-0 w-100">
                                      <b-badge variant="info" class="badge individual-badge"> Individual </b-badge>
                                      <div class="goal-header text-center d-flex align-items-center justify-content-between">
                                        <h5 class="mb-0 obje-name font-weight-bolder mr-2">Revenue for Q1, 2024</h5>
                                        <div class="circle_percent" data-percent="20">
                                          <div class="circle_inner">
                                            <div class="round_per"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="d-flex align-items-center okr-objtype">
                                      <div class="obj-name d-flex align-ites-center">
                                        <div class="quarter-data">
                                          <h6 class="mb-0 text-left">Name</h6>
                                          <p class="value text-left mb-0">Vignesvaran B</p>
                                        </div>
                                      </div>
                                      <div class="obj-period d-flex align-ites-center">
                                        <div class="quarter-data">
                                          <h6 class="mb-0 text-left">Period</h6>
                                          <p class="value text-left mb-0">Q6</p>
                                        </div>
                                      </div>
                                    </div>
                                    <b-button class="expand-icon"><feather-icon icon="PlusIcon" size="18" class="text-primary font-weight-bolder m-0" /></b-button>
                                  </b-card>
                                </li>
                                <li>
                                  <b-card class="relative mb-0">
                                    <div class="mb-0 w-100">
                                      <b-badge variant="info" class="badge individual-badge"> Individual </b-badge>
                                      <div class="goal-header text-center d-flex align-items-center justify-content-between">
                                        <h5 class="mb-0 obje-name font-weight-bolder mr-2">Revenue for Q1, 2024</h5>
                                        <div class="circle_percent" data-percent="20">
                                          <div class="circle_inner">
                                            <div class="round_per"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="d-flex align-items-center okr-objtype">
                                      <div class="obj-name d-flex align-ites-center">
                                        <div class="quarter-data">
                                          <h6 class="mb-0 text-left">Name</h6>
                                          <p class="value text-left mb-0">Vignesvaran B</p>
                                        </div>
                                      </div>
                                      <div class="obj-period d-flex align-ites-center">
                                        <div class="quarter-data">
                                          <h6 class="mb-0 text-left">Period</h6>
                                          <p class="value text-left mb-0">Q6</p>
                                        </div>
                                      </div>
                                    </div>
                                    <b-button class="expand-icon"><feather-icon icon="PlusIcon" size="18" class="text-primary font-weight-bolder m-0" /></b-button>
                                  </b-card>
                                </li>
                              </ul>
                            </div>
                          </li>
                          <li>
                            <b-card class="relative mb-0">
                              <div class="mb-0 w-100">
                                <b-badge variant="info" class="badge team-badge"> Team </b-badge>
                                <div class="goal-header text-center d-flex align-items-center justify-content-between">
                                  <h5 class="mb-0 obje-name font-weight-bolder mr-2">Revenue for Q1, 2024</h5>
                                  <div class="circle_percent" data-percent="40">
                                    <div class="circle_inner">
                                      <div class="round_per"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center okr-objtype">
                                <div class="obj-name d-flex align-ites-center">
                                  <div class="quarter-data">
                                    <h6 class="mb-0 text-left">Team</h6>
                                    <p class="value text-left mb-0">Klizer</p>
                                  </div>
                                </div>
                                <div class="obj-period d-flex align-ites-center">
                                  <div class="quarter-data">
                                    <h6 class="mb-0 text-left">Period</h6>
                                    <p class="value text-left mb-0">Q1</p>
                                  </div>
                                </div>
                              </div>
                              <b-button class="expand-icon"><feather-icon icon="PlusIcon" size="18" class="text-primary font-weight-bolder m-0" /></b-button>
                            </b-card>
                          </li>
                          <li>
                            <b-card class="relative mb-0">
                              <div class="mb-0 w-100">
                                <b-badge variant="info" class="badge team-badge"> Team </b-badge>
                                <div class="goal-header text-center d-flex align-items-center justify-content-between">
                                  <h5 class="mb-0 obje-name font-weight-bolder mr-2">Revenue for Q1, 2024</h5>
                                  <div class="circle_percent" data-percent="10">
                                    <div class="circle_inner">
                                      <div class="round_per"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center okr-objtype">
                                <div class="obj-name d-flex align-ites-center">
                                  <div class="quarter-data">
                                    <h6 class="mb-0 text-left">Team</h6>
                                    <p class="value text-left mb-0">Integrator</p>
                                  </div>
                                </div>
                                <div class="obj-period d-flex align-ites-center">
                                  <div class="quarter-data">
                                    <h6 class="mb-0 text-left">Period</h6>
                                    <p class="value text-left mb-0">Q6</p>
                                  </div>
                                </div>
                              </div>
                              <b-button class="expand-icon"><feather-icon icon="PlusIcon" size="18" class="text-primary font-weight-bolder m-0" /></b-button>
                            </b-card>
                          </li>
                          <li>
                            <b-card class="relative mb-0">
                              <div class="mb-0 w-100">
                                <b-badge variant="info" class="badge team-badge"> Team </b-badge>
                                <div class="goal-header text-center d-flex align-items-center justify-content-between">
                                  <h5 class="mb-0 obje-name font-weight-bolder mr-2">Revenue for Q1, 2024</h5>
                                  <div class="circle_percent" data-percent="5">
                                    <div class="circle_inner">
                                      <div class="round_per"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center okr-objtype">
                                <div class="obj-name d-flex align-ites-center">
                                  <div class="quarter-data">
                                    <h6 class="mb-0 text-left">Team</h6>
                                    <p class="value text-left mb-0">PIM</p>
                                  </div>
                                </div>
                                <div class="obj-period d-flex align-ites-center">
                                  <div class="quarter-data">
                                    <h6 class="mb-0 text-left">Period</h6>
                                    <p class="value text-left mb-0">Q1</p>
                                  </div>
                                </div>
                              </div>
                              <b-button class="expand-icon"><feather-icon icon="PlusIcon" size="18" class="text-primary font-weight-bolder m-0" /></b-button>
                            </b-card>
                          </li>
                          <li>
                            <b-card class="relative mb-0">
                              <div class="mb-0 w-100">
                                <b-badge variant="info" class="badge team-badge"> Team </b-badge>
                                <div class="goal-header text-center d-flex align-items-center justify-content-between">
                                  <h5 class="mb-0 obje-name font-weight-bolder mr-2">Revenue for Q1, 2024</h5>
                                  <div class="circle_percent" data-percent="50">
                                    <div class="circle_inner">
                                      <div class="round_per"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center okr-objtype">
                                <div class="obj-name d-flex align-ites-center">
                                  <div class="quarter-data">
                                    <h6 class="mb-0 text-left">Team</h6>
                                    <p class="value text-left mb-0">QA Touch</p>
                                  </div>
                                </div>
                                <div class="obj-period d-flex align-ites-center">
                                  <div class="quarter-data">
                                    <h6 class="mb-0 text-left">Period</h6>
                                    <p class="value text-left mb-0">Q6</p>
                                  </div>
                                </div>
                              </div>
                              <b-button class="expand-icon"><feather-icon icon="PlusIcon" size="18" class="text-primary font-weight-bolder m-0" /></b-button>
                            </b-card>
                          </li>
                        </ul>
                      </div>
                        </li>
                        <li>
                          <b-card class="relative mb-0">
                                        <div class="mb-0 w-100">
                                          <div class="goal-header text-center d-flex align-items-center justify-content-between">
                                            <h5 class="mb-0 obje-name font-weight-bolder mr-2">Revenue for Q1, 2024</h5>
                                            <div class="circle_percent" data-percent="50">
                                              <div class="circle_inner">
                                                <div class="round_per"></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="obj-period d-flex align-ites-center">
                                          <div class="quarter-data">
                                            <h6 class="mb-0 text-left">Period</h6>
                                            <p class="value text-left mb-0">Q6</p>
                                          </div>
                                        </div>
                            <b-button class="expand-icon"><feather-icon icon="PlusIcon" size="18" class="text-primary font-weight-bolder m-0" /></b-button>
                          </b-card>
                        </li>
                        <li>
                          <b-card class="relative mb-0">
                                        <div class="mb-0 w-100">
                                          <div class="goal-header text-center d-flex align-items-center justify-content-between">
                                            <h5 class="mb-0 obje-name font-weight-bolder mr-2">Revenue for Q1, 2024</h5>
                                            <div class="circle_percent" data-percent="50">
                                              <div class="circle_inner">
                                                <div class="round_per"></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="obj-period d-flex align-ites-center">
                                          <div class="quarter-data">
                                            <h6 class="mb-0 text-left">Period</h6>
                                            <p class="value text-left mb-0">Q6</p>
                                          </div>
                                        </div>
                            <b-button class="expand-icon"><feather-icon icon="PlusIcon" size="18" class="text-primary font-weight-bolder m-0" /></b-button>
                          </b-card>
                        </li>
                      </ul>
                  </div> -->
                </li>
              </ul>
            </div>
          </div>
          <!-- Vertical Company View Tree Design in Custom Order -->
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
import {
  BAvatar,
  BCard,
  BCardText,
  BImg,
  BLink,
  BRow,
  BCol,
  BAvatarGroup,
  VBTooltip,
  BFormTextarea,
  BButton,
  BFormGroup,
  BEmbed,
  BCarousel,
  BCarouselSlide,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { kFormatter } from "@core/utils/filter";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import QuillInput from "@/components/QuillInput.vue";

import $ from "jquery";
import Vue from "vue";
import { bus } from "@/main.js";
import axios from "@axios";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
import Nodes from "./nodes.vue";
export default {
  components: {
    BAvatar,
    BCard,
    BCardText,
    BButton,
    BFormTextarea,
    BImg,
    BFormGroup,
    BRow,
    BLink,
    BCol,
    BAvatarGroup,
    BEmbed,
    QuillInput,
    // Navbar Components
    BCarousel,
    BCarouselSlide,
    Nodes
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  watch: {
    selectedPeriod(oldValue,newValue){
      this.getObjectiveTree();
    }
  },
  data() {
    return {
      show:true,
      searchQuery : '',
      searchResults : [],
      employeesList : [],
      selectedPeriod : {quarter:this.getCurrentQuarter(),year:this.getCurrentYear()},
      periods:[],
      isCollapsed : true,
      nodes: [],
      data: {
        id: "ms",
        data: {
          imageURL: "https://i.pravatar.cc/300?img=68",
          name: "Margret Swanson",
        },
        children: [
          {
            id: "mh",
            data: {
              imageURL: "https://i.pravatar.cc/300?img=69",
              name: "Mark Hudson",
            },
            children: [
              {
                id: "kb",
                data: {
                  imageURL: "https://i.pravatar.cc/300?img=65",
                  name: "Karyn Borbas",
                },
              },
              {
                id: "cr",
                data: {
                  imageURL: "https://i.pravatar.cc/300?img=60",
                  name: "Chris Rup",
                },
              },
            ],
          },
          {
            id: "cs",
            data: {
              imageURL: "https://i.pravatar.cc/300?img=59",
              name: "Chris Lysek",
            },
            children: [
              {
                id: "Noah_Chandler",
                data: {
                  imageURL: "https://i.pravatar.cc/300?img=57",
                  name: "Noah Chandler",
                },
              },
              {
                id: "Felix_Wagner",
                data: {
                  imageURL: "https://i.pravatar.cc/300?img=52",
                  name: "Felix Wagner",
                },
              },
            ],
          },
        ],
      },
      zoom: {
        enabled: true,
        type: "x",
        resetIcon: {
          offsetX: -10,
          offsetY: 0,
          fillColor: "#fff",
          strokeColor: "#37474F",
        },
        selection: {
          background: "#90CAF9",
          border: "#0D47A1",
        },
      },
      companyData:[],
      options: {
        contentKey: "data",
        width: "100%",
        height: 600,
        nodeWidth: 320,
        nodeHeight: 150,
        fontColor: "#636363",
        borderColor: "#BFBFBF",
        childrenSpacing: 50,
        siblingSpacing: 20,
        direction: "top",
        enableExpandCollapse: true,
        nodeTemplate: (content) => this.getContent(content),
        enableToolbar: true,
      },
    };
  },
  created() {

    const periods = [];
    const currentYear = new Date().getFullYear();

    // Loop through the last 3 years, including the current year
    for (let year = currentYear; year > currentYear - 2; year--) {
      // For each year, add all four quarters to the periods array
      for (let quarter = 1; quarter <= 4; quarter++) {
        periods.push({ quarter: `Q${quarter}`, year: `${year}` });
      }
    }
    this.periods = periods;
    
  },
  mounted() {

    this.getTreeParent();
    this.getObjectiveTree();
    this.updateProgress();
    this.fetchEmployees();
    //Fullscreen Click
    document.getElementById('fullscreenIcon').addEventListener('click', function() {
      const treecontent = document.getElementById('treecontent');
      if (treecontent.classList.contains('fullscreen')) {
        treecontent.classList.remove('fullscreen');
        treecontent.classList.add('minimized');
      } else {
        treecontent.classList.remove('minimized');
        treecontent.classList.add('fullscreen');
      }
    });

    $(function () {
      $('.okr-tree ul').hide();
      $('.okr-tree>ul').show();
      $('.okr-tree ul.active').hide();
    });
  },
  beforeDestroy() {
    // Remove the click event listener when the component is destroyed
    this.$el.removeEventListener("click", this.handleDocumentClick);
  },
  methods: {
    onSearch(query){
      if (query.length === 0 ) {
        this.searchResult = [];
        return;
      }
      if(query.length > 2){
        this.searchResults = this.employeesList.filter(item => item.label.toLowerCase().includes(query.toLowerCase()));
      }
    },
    search(string,type){
      try{
        this.$refs['children-org-tree'].search(string,type,this.selectedPeriod);
      }
      catch{
        this.$refs['children-org-tree'][0].search(string,type,this.selectedPeriod);
      }
      this.show = false;
    },
    fetchEmployees() {
      this.$store
        .dispatch("app/fetchInterviewers")
        .then((res) => {
          this.employeesList = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    goto(target){
      if(target == 'all-okrs'){
        return window.open("/list/all-okrs", '_blank');
      }
      if(target == 'tree-okrs'){
        return window.open("/tree-okr", '_self');
      }
      if(target == 'company-tree-okrs'){
        return window.open("/company-okr", '_blank');
      }
    },
    expand(){
      var nodeId = '#org-tree';
      $('.okr-tree ul').show();
      $('.okr-tree>ul').show();
      $('.okr-tree ul.active').show();
      this.isCollapsed = false;
    },
    collapse(){
      $('.okr-tree ul').hide();
      $('.okr-tree>ul').show();
      $('.okr-tree ul.active').hide();
      this.isCollapsed = true;
    },
    getTreeParent(){
      this.isloading = true;
      axios
        .get("objectives/get-okr-tree-parent")
        .then((response) => {
          if (response.data.success) {
            this.companyData = response.data.data;
            // this.getTreeSubNode('company');
          } else {
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Unable to fetch Company Type",
            //     icon: "EditIcon",
            //     variant: "danger",
            //     text: response.data.message,
            //   },
              
            // });

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Unable to fetch Company Type",
                icon: "EditIcon",
                variant: "danger",
                text: response.data.message,
              },
            },{
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
        });
    },
    listClicked(id){
      var nodeId = '#'+id;
      $("#root-node-arrow").toggleClass("activenode");
      $(nodeId).addClass("open-tree");
      $(nodeId).siblings('li').removeClass('open-tree');
      $(nodeId).siblings('li').find('nodes').hide();
      var children = $(nodeId).find('> ul');
      if (children.is(":visible")) {
        children.hide('fast').removeClass('active');
      }
      else {
        children.show('fast').addClass('active');
      }
      this.isloading = false;
    },

    handleDocumentClick(event) {
      let targetElement = event.target;
      // Traverse up the DOM tree to find the element with the class 'clickable'
      while (targetElement && !targetElement.classList.contains("nodes")) {
        targetElement = targetElement.parentElement;
      }
      if (targetElement) {
        const dataValue = targetElement.getAttribute("data-item");
        console.log("Data value:", dataValue);
      }
    },
    ParentClicked() {
      alert("sdf");
    },
    getCurrentYear() {
      const currentDate = new Date();
      return currentDate.getFullYear();
    },
    getCurrentQuarter() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // JavaScript months are 0-indexed, so add 1

      // Calculate the quarter based on the current month
      if (currentMonth >= 1 && currentMonth <= 3) {
        return "Q1";
      } else if (currentMonth >= 4 && currentMonth <= 6) {
        return "Q2";
      } else if (currentMonth >= 7 && currentMonth <= 9) {
        return "Q3";
      } else {
        return "Q4";
      }
    },
    getObjectiveTree(parent_id = 'company') {
      axios
        .post("Objectives/get-okr-tree-subnode/"+parent_id, 
        {
          quarter : this.selectedPeriod.quarter,
          year : this.selectedPeriod.year,

        }
        )
        .then((response) => {
          if (response.data.success) {
            this.nodes = response.data.subnodes;

            // var tree = new ApexTree(document.getElementById("svg-tree"), this.options);
            // var graph = tree.render(this.nodes);

            this.$nextTick(() => {
              this.updateProgress();
              // const elements = this.$el.querySelectorAll(".nodes");
              // elements.forEach((element) => {
              //   element.addEventListener("click", this.handleDocumentClick);
              // });
            });
          } else {
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Unable to fetch Objective Tree",
            //     icon: "EditIcon",
            //     variant: "danger",
            //     text: response.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Unable to fetch Company Type",
                icon: "EditIcon",
                variant: "danger",
                text: response.data.message,
              },
            },{
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
        });
    },
    updateProgress() {
      // Circle Progress bar Design
      $(".circle_percent").each(function() {
        var $this = $(this),
        $dataV = $this.attr('percent'),
        $dataDeg = $dataV * 3.6,
        $round = $this.find(".round_per");
        $round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");	
        $this.append('<div class="circle_inbox"><span class="percent_text"></span></div>');
        $this.prop('Counter', 0).animate({Counter: $dataV},
        {
          duration: 2000, 
          easing: 'swing', 
          step: function (now) {
                  $this.find(".percent_text").text(Math.ceil(now)+"%");
              }
          });
        if($dataV >= 51){
          $round.css("transform", "rotate(" + 360 + "deg)");
          setTimeout(function(){
            $this.addClass("percent_more");
          },1000);
          setTimeout(function(){
            $round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");
          },1000);
        } 
      });
    },
  },
};
</script>